<div class="pl-5 py-5 flex h-[calc(100svh-80px)] overflow-hidden gap-[2%]" *transloco="let t">
  @if(showModalEvent){
  <std-modal [closeOnOutside]="false" [show]="showModalEvent" (close)="showModalEvent = false">
    <div header class="text-white font-semibold">Crea turno</div>
    <div content class="min-w-[350px]">
      <std-select direction="down" (onChangeValue)="changeSelectShift($event,'selectedEmployee')" class="max-w-[400px]"
        typeOfFiltrableSelect="includes" customLabel="label-input" [filterable]="true"
        customClassContainerElement="max-h-[250px] overflow-y-scroll custom-scrollbar" label="Dipendente" bindValue="id"
        bindLabel="completeName" customClassContaier="border-primary custom-select" placeholder="Seleziona dipendente"
        [data]="employees"></std-select>
      @if(shift['selectedEmployee']){ <std-select direction="down" (onChangeValue)="changeSelectShift($event,'selectedJob')"
        class="max-w-[400px]" typeOfFiltrableSelect="includes" customLabel="label-input" [filterable]="true"
        customClassContainerElement="max-h-[250px] overflow-y-scroll custom-scrollbar" label="Mansione" bindValue="id"
        bindLabel="name" customClassContaier="border-primary custom-select" placeholder="Seleziona mansione"
        [data]="jobsEmployee"></std-select>}
      <div class="w-full">
        <div (click)="showStart = true">
          <div class="pointer-events-none"><std-input customLabel="label-input mt-2" customInputClass="custom-input"
              type="text" labelPosition="top" [placeholder]="t('common.from')" [label]="t('common.from')"
              [(ngModel)]="shift.startDateShow"></std-input></div>
        </div>

      </div>
      <div class="w-full">
        <div (click)="showEnd = true">
          <div class="pointer-events-none"><std-input customLabel="label-input mt-2" customInputClass="custom-input"
              type="text" labelPosition="top" [placeholder]="t('common.to')" [label]="t('common.to')"
              [(ngModel)]="shift.endDateShow"></std-input></div>
        </div>

      </div>
      <div class="w-full mt-4"
        [ngClass]="{'opacity-35 pointer-events-none': !shift.startDate || !shift.endDate || !shift.selectedJob || !shift.selectedEmployee }">
        <std-button (click)="confirmModal()" size="sm">{{t('common.addEvent')}}</std-button>
      </div>
    </div>
  </std-modal>
  }

  @if(showModalCreateCalendar){

  <std-modal [closeOnOutside]="false" [show]="showModalCreateCalendar" (close)="showModalCreateCalendar = false">
    <div header class="text-white font-semibold">Crea calendario</div>
    <div content class="max-w-[350px]">

      <div class="label-input">@if(currentCalendarMode == 'weekly' && !selectedEmployee.id && !selectedJob.id){Proseguendo il calendario della settimana attuale sarà sovrascritto e sostituito con un
        calendario generato automaticamente in base ai parametri del punto vendita}
      @if(currentCalendarMode !== 'weekly' || selectedEmployee.id || selectedJob.id){La funzione crea calendario è disponibile solo nella versione settimanale e senza filtri attivi}</div>
      <div class="w-full mt-4">@if(currentCalendarMode == 'weekly' && !selectedEmployee.id && !selectedJob.id){
        <std-button (click)="createCalendar()" size="sm">Crea calendario</std-button>
      
      }</div>
    </div>
  </std-modal>
  }
  <div class="w-full testing" [ngClass]="{'!w-[70%]': showAlerts}">
    <div class="flex flex-wrap gap-5 mb-5 items-end">
      <std-select direction="down" (onChangeValue)="changeSelect($event,'selectedStore')" class="max-w-[400px]"
        typeOfFiltrableSelect="includes" customLabel="label-input" [filterable]="true"
        customClassContainerElement="max-h-[250px] overflow-y-scroll custom-scrollbar" label="Punto vendità"
        bindValue="id" bindLabel="name" customClassContaier="border-primary custom-select"
        placeholder="Seleziona punto vendità" [data]="stores"></std-select>
      @if(showSelectFilters){<std-select direction="down" (onChangeValue)="changeSelect($event,'selectedJob')" class="max-w-[400px]"
        typeOfFiltrableSelect="includes" customLabel="label-input" [filterable]="true"
        customClassContainerElement="max-h-[250px] overflow-y-scroll custom-scrollbar" label="Mansione" bindValue="id"
        bindLabel="name" customClassContaier="border-primary custom-select" placeholder="Seleziona mansione"
        [data]="jobs"></std-select>
      <std-select direction="down" (onChangeValue)="changeSelect($event,'selectedEmployee')" class="max-w-[400px]"
        typeOfFiltrableSelect="includes" customLabel="label-input" [filterable]="true"
        customClassContainerElement="max-h-[250px] overflow-y-scroll custom-scrollbar" label="Dipendente" bindValue="id"
        bindLabel="completeName" customClassContaier="border-primary custom-select" placeholder="Seleziona dipendente"
        [data]="employees"></std-select>}
      @if(showCalendar){<std-button (click)="showModalCreateCalendar = true">Crea calendario</std-button>}
      @if(showCalendar &&( selectedJob?.id || selectedEmployee?.id)){<std-button (click)="resetFilters()">Resetta filtri</std-button>}
      @if(!showAlerts && alerts.length > 0 && currentCalendarMode == 'weekly' && !selectedJob?.id && !selectedEmployee?.id){<div (click)="showAlerts = true"
        class="rounded-full select-none bg-primary border-[1px] border-secondary text-red-500 font-bold text-[18px] relative flex items-center place-content-center size-12 ml-auto cursor-pointer">
        {{alerts.length}}!</div>}
        <std-button (click)="deleteAllCalendar()" size="sm">Delete all</std-button>
         <std-button (click)="useRemainingHours3()" size="sm">Use remaining hours</std-button>
         <std-button (click)="logRemainingHours()" size="sm">Log remaining hours</std-button>
    </div>
    @if(showCalendar){

    <std-calendar
          [calendarModes]="calendarModes"
            (changeEventTime)="moveEvent($event)"
            [scrollHours]="true"
            [translatePipe]="t"
            [canResizeEvents]="true"
            
            [showAllEvents]="true"
            [hoursToScroll]="10"
            [timeSplitter]="30"
            weeklyShowHoursMode="daily"
            [daysOff]="[]"
            [show]="showModalEventDelete"
            (close)="currentEventSelected = {};showModalEvent = false;showModalEventDelete = false"
      (showEvent)="currentEventSelected= {};isEditEvent = false;
          currentEventSelected = $event;
          manageElementsEvent($event) 
        "
            [mobileItems]="mobileItems"
            [arrayEvents]="arrayEvents" (close)="currentEventSelected = {}"
            (onDayClick)="currentEventSelected= {};isEditEvent = false;dateSelect($event)"
      [currentDate]="currentDate"
            [currentMode]="currentCalendarMode"
            [currentDate]="currentDate"
            (changeMode)="changeMode($event)"
            >
      <div customModal class="size-full p-5 bg-white w-full h-full min-w-[600px] max-w-[650px]">
        <div class="w-full flex justify-between items-center">
          <div class="w-full h-full flex gap-2 items-center">
            <div class="w-[6px] h-[44px] bg-[#D9D9D9]"></div>
            <div class="flex flex-col items-start justify-center">
              <div class="text-[16px] text-[#102A35] font-medium leading-[19.2px]">
                {{ getEventTime(currentEventSelected.dateStart) }}/
                {{ getEventTime(currentEventSelected.dateEnd) }}
              </div>
              <div class="text-[20px] font-medium text-[#102A35] leading-6">
                {{ currentEventSelected.name }}
              </div>
            </div>
          </div>
        </div>
        <div>{{currentEventSelected?.employee?.firstName}} {{currentEventSelected?.employee?.lastName}}</div>
        <div class="mt-5"><std-button (click)="deleteEvent(currentEventSelected.id)">Elimina turno</std-button></div>
      </div>
    </std-calendar>}
    @if(!showCalendar){
    <div class="text-[48px] font-semibold text-primary">Seleziona un punto vendita</div>
    }
  </div>
  <div class="w-[2px] bg-primary rounded-full"></div>
  @if(showAlerts){<div class="w-[25%] border-primary">

    <div class="text-primary text-title font-semibold flex place-content-between items-center">
      <div>AVVISI</div>
      <div (click)="showAlerts = false" class="text-[40px] font-bold cursor-pointer">→</div>
    </div>
    <div class="h-[calc(100svh-180px)] overflow-y-scroll custom-scroll">@for (alert of alerts; track $index) {
      @if(alert.type == 1){<div class="flex p-2 border-primary border-[2px] mb-5 rounded-[8px] place-content-between">
        {{t('daysOfTheWeek.'+alert.day)}} - {{alert.h}}:{{alert.m == 0 ? '00': '30'}}/{{alert.endH}}:{{alert.endM == 0 ?
        '00': '30'}} - {{alert.jobName}} <div
          class="ml-2 bg-primary flex items-center place-content-center cursor-pointer px-4 text-medium rounded-full text-white"
          (click)="createSuggestion(alert)">Suggerimento</div>
      </div>}
      @if(alert.type == 2 || alert.type == 4){<div class="flex p-2 border-primary border-[2px] mb-5 rounded-[8px] place-content-between">
        {{t('daysOfTheWeek.'+alert.day)}} {{alert.desc}}</div>}
        @if(alert.type == 3){<div class="flex p-2 border-primary border-[2px] mb-5 rounded-[8px] place-content-between">
        {{alert.desc}}</div>}
        @if(alert.type == 6){<div class="flex p-2 border-primary border-[2px] mb-5 rounded-[8px] place-content-between">
        {{alert.desc}}</div>}
      @if(alert.type == 5){<div class="flex p-2 border-primary border-[2px] mb-5 rounded-[8px] place-content-between">
        {{t('daysOfTheWeek.'+alert.day)}} - {{alert.h}}:{{alert.m == 0 ? '00': '30'}}/{{alert.endH}}:{{alert.endM == 0 ?
        '00': '30'}} - Mancano {{alert.missingNumber}} persone per fascia alta
        <!-- <div
          class="ml-2 bg-primary flex items-center place-content-center cursor-pointer px-4 text-medium rounded-full text-white"
          >Suggerimento</div> -->
      </div>}
      }
    </div>
  </div>}
  @if(showStart){<div
    class="fixed z-[10000] left-0 w-screen h-screen top-0 bg-black bg-opacity-25 bg-transparent flex items-center place-content-center">
    <std-time-picker [showClock]="false" customClassNumbers="!text-black"
      (changeDate)="adjustDateSelect($event,'startDate');shift.startDateShow = $event.formattedTime"
      [stepMinutes]="30" [use24h]="true" [startingTime]="shift.startDateShow ?? '00:00'">
      <div footer>
        <div>
          <std-button (click)="showStart = false">{{t('common.confirm')}}</std-button>
        </div>
      </div>
    </std-time-picker>
  </div>}


  @if(showEnd){<div
    class="fixed z-[10000] left-0 w-screen h-screen top-0 bg-black bg-opacity-25 bg-transparent flex items-center place-content-center">
    <std-time-picker [showClock]="false" customClassNumbers="!text-black"
      (changeDate)="adjustDateSelect($event,'endDate');shift.endDateShow = $event.formattedTime" [stepMinutes]="30"
      [use24h]="true" [startingTime]="shift.endDateShow ?? '00:00'">
      <div footer>
        <div>
          <std-button (click)="showEnd = false">{{t('common.confirm')}}</std-button>
        </div>
      </div>
    </std-time-picker>
  </div>}
</div>